import urlUtils from '../../utils/urlUtils';
import * as marketNames from './marketNames';

export default class ConfigClient {
    constructor(marketConfigsList) {
        this.marketConfigsList = marketConfigsList;
    }

    getMarketConfigImport(market) {
        const currentUrl = urlUtils.getOriginLocation();
        const href = market ? urlUtils.join(currentUrl, market.toLowerCase()) : urlUtils.getCurrentLocation();
        const marketConfigImport = this.marketConfigsList.find(({urls}) =>
            urls.some((url) => checkIfConfigUrlMatchToTheCurrentLocation(url, href))
        );

        return marketConfigImport;
    }

    async getMarketConfig(market) {
        const marketConfigImport = this.getMarketConfigImport(market);
        const configResponse = await marketConfigImport?.configImport();

        return configResponse?.default;
    }

    async getConfig(market) {
        const marketConfig = await this.getMarketConfig(market);

        return {...marketConfig, isMarketInitialized: !!marketConfig};
    }
}

export const checkIfConfigUrlMatchToTheCurrentLocation = (configUrl, currentUrl) => {
    if (!currentUrl.startsWith(configUrl)) return false;
    if (configUrl.endsWith('/')) return true;

    const nextCharAfterUrl = currentUrl.split(configUrl).pop()[0];
    const isEndOrSomeSpecialCharacter = nextCharAfterUrl ? nextCharAfterUrl.match(/[@#$&/?]/i) : true;

    return isEndOrSomeSpecialCharacter;
};

export const getMarketConfigList = (handler) => {
    const marketConfigsList = Object.entries(marketNames)
        .reverse()
        .map(([key, marketName]) => handler(marketName));

    return marketConfigsList;
};
